import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';


const firebaseConfig = {
  apiKey: "AIzaSyBdKlkQ0BqDQFjpn5DTxI1nkK2Js8dYllI",
  authDomain: "braseria-60c58.firebaseapp.com",
  projectId: "braseria-60c58",
  storageBucket: "braseria-60c58.appspot.com",
  messagingSenderId: "514150953627",
  appId: "1:514150953627:web:6640c37cb95a19564c0c3e",
  measurementId: "G-BC7NSK6KE7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
/*connectAuthEmulator(auth, 'http://localhost:9099')*/
export const db = getFirestore(app);
/*connectFirestoreEmulator(db, '127.0.0.1', 8080)*/
export const storage = getStorage(app);
export const functions = getFunctions(app);
/*connectFunctionsEmulator(functions, '127.0.0.1', 5001)*/

export default app;
